import React from "react";
import { makeStyles } from '@material-ui/core/styles';
import MetricCard from "./MetricCard";

const MetricGroup = ({ config, props }) => {
    const classes = useStyles();

    let cards = props?.metrics?.statuses || [];
    return (
        <div className={classes.container}>
            {
                cards.map((card, index) => {
                    return (
                        <MetricCard key={index} status={card}/>
                    )
                })
            }
        </div>
    )

}

const useStyles = makeStyles((theme) => ({
    container: {
        display: "grid",
        gridAutoFlow: "column",
        gap: `${theme.spacing(3)}px`
    }
}));

export default MetricGroup;